import Badge from '../../../api/Badge';
import * as types from './mutation-types';

export const store = async ({commit}, {params}) => {
    await new Badge().store(params)
};

export const show = async ({commit}, {id}) => {
    const json = await new Badge().show(id);

    commit(types.BADGE, json);

};

export const update = async (context, {id, params}) => {
    await new Badge().update(id, params)
};

export const destroy = async (context, {id}) => {
    await new Badge().destroy(id)
};

export default {
    store,
    show,
    update,
    destroy,
};



// WEBPACK FOOTER //
// ./src/store/modules/badge/actions.js